import './src/stylesheets/styles.scss'
import '@fontsource/licorice'

import { stickUtmParameters } from './src/utm'
import { freshpaint, freshpaintTrack } from './src/freshpaint'
import { initializeAnalytics } from './src/analytics'
import { tradeDesk } from './src/tradedesk'
import React from 'react'
import PageRouter from './src/reporting/page-router'
import { taboola } from './src/taboola'
import { outbrain } from './src/outbrain'
import { demandbase } from './src/demandbase'

declare global {
  interface Window {
    _tfa?: Array<any>
    obApi?: (eventName: string, eventData: any) => void
  }
}

export const onClientEntry = (): void => {
  freshpaint()
  initializeAnalytics()
  stickUtmParameters()
  tradeDesk()
  taboola()
  outbrain()
  demandbase()
}

export const onRouteUpdate = () => {
  setTimeout(() => {
    freshpaintTrack('engaged_page_views')
    window._tfa?.push({notify: 'event', name: 'engaged_page_view', id: 1859687})
    window.obApi && window.obApi('track', 'ENGAGED_PAGE_VIEW')
  }, 30000)
}

export const wrapPageElement = ({ element, props }) => {
  return <PageRouter {...props}>{element}</PageRouter>
}
